document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-stonovia-gallery]').forEach(function (gallery) {
    var filters = Array.from(gallery.querySelectorAll('[data-gallery-filter]'));
    var selects = Array.from(gallery.querySelectorAll('[data-gallery-select]'));
    var clearButton = gallery.querySelector('[data-gallery-clear]');
    var resultCount = gallery.querySelector('[data-gallery-result-count]');
    var showMoreButton = gallery.querySelector('[data-gallery-show-more]');
    var cards = Array.from(gallery.querySelectorAll('[data-gallery-card]'));
    var gridVideos = Array.from(gallery.querySelectorAll('[data-gallery-grid-video]'));
    gridVideos.forEach(function (video) {
      if (video.dataset.playbackRate) video.playbackRate = Number(video.dataset.playbackRate);
    });
    var modal = gallery.querySelector('[data-gallery-modal]');
    var modalImage = gallery.querySelector('[data-gallery-modal-image]');
    var modalVideo = gallery.querySelector('[data-gallery-modal-video]');
    var activeCards = cards.slice();
    var activeIndex = 0;
    var activeCategory = 'all';
    var visibleLimit = 20;

    function selectedValue(name) {
      var select = selects.find(function (item) { return item.dataset.gallerySelect === name; });
      return select ? select.value : 'all';
    }

    function matchesFilters(card) {
      var color = selectedValue('color');
      var application = selectedValue('application');
      var filtersAreActive = activeCategory !== 'all' || color !== 'all' || application !== 'all';
      return (card.dataset.filterOnly !== 'true' || filtersAreActive) &&
        (activeCategory === 'all' || card.dataset.category === activeCategory) &&
        (color === 'all' || card.dataset.color === color) &&
        (application === 'all' || (card.dataset.application || '').split(' ').indexOf(application) !== -1);
    }

    function arrange() {
      var seenImages = new Set();
      var matchingCards = cards.filter(matchesFilters).sort(function (a, b) {
        return Number(a.classList.contains('spg-card--supplemental')) - Number(b.classList.contains('spg-card--supplemental'));
      }).filter(function (card) {
        var trigger = card.querySelector('[data-gallery-open]');
        var mediaKey = trigger && trigger.dataset.video ? 'video:' + trigger.dataset.video : 'image:' + ((trigger && trigger.dataset.image) || '').split('?')[0];
        if (!mediaKey || seenImages.has(mediaKey)) return false;
        seenImages.add(mediaKey);
        return true;
      });
      var visibleCards = matchingCards.slice(0, visibleLimit);
      var layouts = visibleCards.map(function () { return 'square'; });
      var lastRowCount = visibleCards.length % 3;
      if (lastRowCount === 1) layouts[layouts.length - 1] = 'full';
      if (lastRowCount === 2) {
        layouts[layouts.length - 2] = 'half';
        layouts[layouts.length - 1] = 'half';
      }
      cards.forEach(function (card) {
        card.hidden = true;
        var cardVideo = card.querySelector('[data-gallery-grid-video]');
        if (cardVideo) cardVideo.pause();
        card.classList.remove('spg-card--wide', 'spg-card--tall', 'spg-card--square', 'spg-card--full', 'spg-card--half');
      });
      visibleCards.forEach(function (card, visibleIndex) {
        card.hidden = false;
        card.classList.add('spg-card--' + layouts[visibleIndex]);
      });
      var matchCount = matchingCards.length;
      if (resultCount) resultCount.textContent = matchCount + (matchCount === 1 ? ' project' : ' projects');
      if (showMoreButton) showMoreButton.hidden = matchCount <= visibleLimit;
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        activeCategory = button.dataset.galleryFilter;
        visibleLimit = 20;
        arrange();
      });
    });

    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        visibleLimit = 20;
        arrange();
      });
    });

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        activeCategory = 'all';
        visibleLimit = 20;
        filters.forEach(function (item) {
          var selected = item.dataset.galleryFilter === 'all';
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', String(selected));
        });
        selects.forEach(function (select) { select.value = 'all'; });
        arrange();
      });
    }

    if (showMoreButton) {
      showMoreButton.addEventListener('click', function () {
      visibleLimit += 20;
        arrange();
      });
    }

    function modalItems() {
      return Array.from(gallery.querySelectorAll('[data-gallery-open]')).filter(function (button) {
        var card = button.closest('[data-gallery-card]');
        return !card || !card.hidden;
      });
    }

    function renderModal(button) {
      if (button.dataset.video) {
        modalImage.hidden = true;
        modalVideo.hidden = false;
        if (modalVideo.src !== button.dataset.video) modalVideo.src = button.dataset.video;
        modalVideo.setAttribute('aria-label', button.dataset.title + ' project video');
        modalVideo.playbackRate = Number(button.dataset.playbackRate || 1);
        modalVideo.play().catch(function () {});
      } else {
        modalVideo.pause();
        modalVideo.removeAttribute('src');
        modalVideo.load();
        modalVideo.hidden = true;
        modalImage.hidden = false;
        modalImage.src = button.dataset.image;
        modalImage.alt = button.dataset.title;
      }
      gallery.querySelector('[data-gallery-modal-category]').textContent = button.dataset.category;
      gallery.querySelector('[data-gallery-modal-title]').textContent = button.dataset.title;
      gallery.querySelector('[data-gallery-modal-caption]').textContent = button.dataset.caption || '';
      gallery.querySelector('[data-gallery-modal-link]').href = button.dataset.link || '#';
    }

    gallery.querySelectorAll('[data-gallery-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        activeCards = modalItems();
        activeIndex = activeCards.indexOf(button);
        renderModal(button);
        if (typeof modal.showModal === 'function') modal.showModal();
      });
    });

    function step(direction) {
      if (!activeCards.length) return;
      activeIndex = (activeIndex + direction + activeCards.length) % activeCards.length;
      renderModal(activeCards[activeIndex]);
    }

    function closeModal() {
      modalVideo.pause();
      modal.close();
    }

    gallery.querySelector('[data-gallery-close]').addEventListener('click', closeModal);
    gallery.querySelector('[data-gallery-prev]').addEventListener('click', function () { step(-1); });
    gallery.querySelector('[data-gallery-next]').addEventListener('click', function () { step(1); });
    modal.addEventListener('click', function (event) { if (event.target === modal) closeModal(); });
    modal.addEventListener('close', function () { modalVideo.pause(); });

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target.closest('[data-gallery-card]');
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && (!card || !card.hidden)) {
            entry.target.play().catch(function () {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: [0, 0.35, 0.7] });
      gridVideos.forEach(function (video) { videoObserver.observe(video); });
    }
    arrange();
  });
});
